import { collections } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function CollectionIndex() {
  return (
    <section className="border-b border-background-200 bg-background-100 scroll-mt-32">
      <div className="px-4 md:px-6 py-8 md:py-12">
        <SectionHeading
          id="collections"
          index="04"
          title="合集索引"
          subtitle="把散落的片段按主题装订成册，回头翻的时候一目了然"
          actionText="浏览全部合集"
        />

        <div className="mt-5 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {collections.map((item) => (
            <article
              key={item.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative w-full h-[260px] md:h-[300px] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`黑料网曝合集索引 ${item.title}`}
                  title={`黑料网曝最新合集 ${item.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
                <span className="absolute top-3 left-3 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 rounded-md bg-background-50/90 px-2.5 py-1 text-xs text-foreground-800">
                  {item.count}
                </span>
                <h4 className="absolute bottom-3 left-4 right-4 font-heading text-lg md:text-xl font-bold text-background-50">
                  {item.title}
                </h4>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-sm leading-relaxed text-foreground-600 hlwp-clamp-2">
                  {item.desc}
                </p>
                <a
                  href="#collections"
                  className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600 transition-colors hover:text-primary-700 cursor-pointer whitespace-nowrap"
                >
                  打开合集
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}